import { render, staticRenderFns } from "./Bonus.vue?vue&type=template&id=dd0dd51a&scoped=true&lang=html"
import script from "./Bonus.vue?vue&type=script&lang=js"
export * from "./Bonus.vue?vue&type=script&lang=js"
import style0 from "./Bonus.vue?vue&type=style&index=0&id=dd0dd51a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0dd51a",
  null
  
)

export default component.exports